module.exports = __webpack_public_path__ + "media/customizations/onvie/logo-967dea635eaac8d3a8f947839f9dd09d.png";